export const environment = {
    production: false,
    //apiBaseUrl: 'http://localhost:3002', // Local API
    apiBaseUrl: 'https://api.efficx.com/service' // Deployed API
  };
  